// src/pages/admin/CapitalReductionPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมลดทุน”
import CapitalReductionForm from "../../forms/meeting/Meeting for Capital Reduction/MeetingforCapitalReduction";

function CapitalReductionPage() {
  return (
    <FormWrapper
      title="เชิญประชุมลดทุน"
      FormComponent={CapitalReductionForm}
      formKey="capital-reduction"
    />
  );
}

export default CapitalReductionPage;
